import React, { Component } from "react";
import { connect } from "react-redux";
import { createComment, creatingComment } from "../../../redux/siteMonitoring/commentActions";
import { noteIsDisabled } from "../../../redux/siteMonitoring/noteActions";
import Chat from "../../Chat/Chat";

class CommentsTab extends Component {

	addMessage(message) {
		this.props.createComment(this.props.editingNote, creatingComment(this.props.editingNote, message, this.props.activeUser), this.props.activeUser)
	}

	render() {
		if (!this.props.editingNote)
			return null;

		let disabled = noteIsDisabled(this.props.siteMonitoring, this.props.editingNote, this.props.activeUser);

		return <div>
			<Chat disabled={disabled} messages={this.props.comments} addMessage={this.addMessage.bind(this)} />
		</div>;
	}
}

const mapStateToProps = (state) => {
	return {
		siteMonitoring: state.siteMonitoring.currentSiteMonitoring,
		activeUser: state.activeUser,
		editingNote: state.notes.editingNote,
		comments: state.notes.comments
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		createComment: (note, comment, user) => dispatch(createComment(note, comment, user)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(CommentsTab);
